import { render, staticRenderFns } from "./ProgressoModal.vue?vue&type=template&id=2286c235&"
import script from "./ProgressoModal.vue?vue&type=script&lang=js&"
export * from "./ProgressoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports